import { routeTree } from '@/routeTree.gen'
import { createRouter } from '@tanstack/react-router'
import { queryClient } from '@/lib/query-client'

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'viewport',
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
